import { Stack } from 'expo-router';
import { useEffect } from 'react';
import { Platform } from 'react-native';

export default function RootLayout() {
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  }, []);

  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;
    const stopGesture = (event: Event) => event.preventDefault();
    const stopPinch = (event: TouchEvent) => { if (event.touches.length > 1) event.preventDefault(); };
    document.addEventListener('gesturestart', stopGesture, { passive: false });
    document.addEventListener('gesturechange', stopGesture, { passive: false });
    document.addEventListener('gestureend', stopGesture, { passive: false });
    document.addEventListener('touchmove', stopPinch, { passive: false });
    return () => {
      document.removeEventListener('gesturestart', stopGesture);
      document.removeEventListener('gesturechange', stopGesture);
      document.removeEventListener('gestureend', stopGesture);
      document.removeEventListener('touchmove', stopPinch);
    };
  }, []);

  return <Stack screenOptions={{ headerShown: false }} />;
}
